var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticStyle: { "enable-background": "new 0 0 1000 1000" },
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        version: "1.1",
        id: "Layer_1",
        x: "0px",
        y: "0px",
        width: "100%",
        height: "100%",
        viewBox: "0 0 1000 1000",
        "xml:space": "preserve",
      },
    },
    [
      _c(
        "g",
        { attrs: { id: "Group_175", transform: "translate(-708.365 -258.5)" } },
        [
          _c(
            "g",
            { attrs: { id: "Group_19", transform: "translate(685.5 -61.5)" } },
            [
              _c("path", {
                staticClass: "st0",
                attrs: { id: "Vector_2", d: "M401.26,701.04v274" },
              }),
              _vm._v(" "),
              _c(
                "g",
                { attrs: { id: "Frame_1", transform: "translate(174 320)" } },
                [
                  _c("path", {
                    staticClass: "st1",
                    attrs: {
                      id: "Frame_1-2",
                      d: "M227.26,313.04L227.26,313.04c13.25,0,24,10.75,24,24l0,0c0,13.25-10.75,24-24,24l0,0     c-13.25,0-24-10.75-24-24l0,0C203.26,323.79,214.01,313.04,227.26,313.04z",
                    },
                  }),
                  _vm._v(" "),
                  _c("circle", {
                    staticClass: "st2",
                    attrs: {
                      id: "Ellipse_1",
                      cx: "227.26",
                      cy: "337.04",
                      r: "14.4",
                    },
                  }),
                  _vm._v(" "),
                  _c("circle", {
                    staticClass: "st3",
                    attrs: {
                      id: "Ellipse_2",
                      cx: "227.26",
                      cy: "337.04",
                      r: "14.4",
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _c(
                "text",
                {
                  staticClass: "st1 st4 st5 st6",
                  attrs: { transform: "matrix(1 0 0 1 419.2602 761.0404)" },
                },
                [_vm._v("SUPSIS’e")]
              ),
              _vm._v(" "),
              _c(
                "text",
                {
                  staticClass: "st1 st4 st5 st6",
                  attrs: { transform: "matrix(1 0 0 1 419.2602 841.0404)" },
                },
                [_vm._v("Hoşgeldiniz")]
              ),
              _vm._v(" "),
              _c(
                "text",
                {
                  staticClass: "st1 st7 st8",
                  attrs: { transform: "matrix(1 0 0 1 419.2602 929.0404)" },
                },
                [_vm._v("Bütün")]
              ),
              _vm._v(" "),
              _c(
                "text",
                {
                  staticClass: "st1 st9 st8",
                  attrs: { transform: "matrix(1 0 0 1 514.1797 929.0404)" },
                },
                [_vm._v("iletişim")]
              ),
              _vm._v(" "),
              _c(
                "text",
                {
                  staticClass: "st1 st7 st8",
                  attrs: { transform: "matrix(1 0 0 1 419.2602 959.0404)" },
                },
                [_vm._v("ihtiyaçlarınız için")]
              ),
              _vm._v(" "),
              _c(
                "text",
                {
                  staticClass: "st1 st9 st8",
                  attrs: { transform: "matrix(1 0 0 1 674.1654 959.0404)" },
                },
                [_vm._v("SUPSIS")]
              ),
              _vm._v(" "),
              _c(
                "text",
                {
                  staticClass: "st1 st7 st8",
                  attrs: { transform: "matrix(1 0 0 1 419.2602 989.0404)" },
                },
                [_vm._v("yanınızda!")]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "g",
            {
              attrs: {
                id: "Group_174",
                transform: "translate(558.365 369.591)",
              },
            },
            [
              _c("path", {
                staticClass: "st1",
                attrs: {
                  id: "Path_12",
                  d: "M441.03,434.16c-0.47,3.09-0.92,6.09-1.48,9.78c-2.07-3.38-3.89-6.18-5.51-9.07    c-0.73-1.53-2.24-2.55-3.94-2.64c-3.14-0.34-6.24-1-9.35-1.57c-8.01-1.45-11.7-6.69-10.36-14.74c2.33-14.06,4.68-28.11,7.04-42.17    c1.24-7.38,6.98-11.28,14.43-10c11.66,2.01,23.34,3.93,35.02,5.85c8.6,1.41,12.32,6.72,10.84,15.38    c-2.37,13.91-4.69,27.82-6.98,41.74c-1.11,6.69-6.27,10.84-13,10.03c-5.18-0.62-10.3-1.64-15.45-2.48    C441.93,434.22,441.58,434.21,441.03,434.16z M414.6,418.31c-0.05,4.51,2.39,7.23,6.37,7.9c12.11,2.01,24.22,4.03,36.32,6.06    c4.71,0.79,8.13-1.44,8.95-6.2c2.45-14.34,4.84-28.69,7.18-43.05c0.79-4.88-1.48-8-6.35-8.83c-11.89-2.02-23.78-3.99-35.68-5.9    c-5.94-0.95-8.75,1.3-9.7,7.25c-1.5,9.36-3.1,18.7-4.66,28.05C416.18,408.72,415.33,413.86,414.6,418.31z",
                },
              }),
              _vm._v(" "),
              _c("path", {
                staticClass: "st1",
                attrs: {
                  id: "Path_13",
                  d: "M414.45,432.86c0.33,1.68,0.61,3.18,0.95,4.95c-4.25,0.82-8.38,1.74-12.56,2.39    c-2.13,0.14-4.02,1.45-4.89,3.4c-1.2,2.5-2.76,4.82-4.53,7.83c-0.66-3.36-1.19-6.09-1.77-9.06c-4.63,0.88-9.07,1.83-13.54,2.53    c-2.58,0.53-5.23,0.7-7.85,0.5c-4.53-0.57-8.19-4.48-9.01-9.16c-2.65-14.98-5.26-29.96-7.83-44.94    c-0.89-6.23,3.35-12.03,9.55-13.07c12.73-2.31,25.47-4.52,38.23-6.62c5.91-0.98,11.58,3.31,12.76,9.52    c-1.56,0.29-3.11,0.58-4.62,0.86c-2.51-4.93-4.26-5.85-9.79-4.9c-11.73,2-23.46,4.05-35.19,6.14c-4.46,0.8-6.51,4.03-5.72,8.54    c2.47,14.03,4.9,28.07,7.31,42.12c0.88,5.17,3.84,7.42,9.02,6.46c12.71-2.38,25.41-4.84,38.12-7.26    C413.45,433,413.82,432.95,414.45,432.86z",
                },
              }),
              _vm._v(" "),
              _c("path", {
                staticClass: "st1",
                attrs: {
                  id: "Path_20",
                  d: "M408.45,410.07c-0.25,10.78-8.85,19.5-19.63,19.9c-10.2,0.48-19.46-7.68-20.46-18.05    c-0.05-0.51-0.03-1.03-0.05-1.54c-0.04-1.64,0.68-2.77,2.36-2.87c1.81-0.11,2.61,1.06,2.78,2.75c0.05,0.95,0.16,1.9,0.33,2.84    c1.7,8,9.58,13.11,17.58,11.41s13.11-9.58,11.41-17.58c-0.07-0.34-0.16-0.68-0.25-1.01c-0.12-0.43-0.24-0.85-0.33-1.28    c-0.38-1.25,0.32-2.58,1.58-2.97c0.02,0,0.03-0.01,0.05-0.01c1.16-0.52,2.52,0.01,3.04,1.17c0.06,0.13,0.11,0.27,0.14,0.41    C407.62,405.46,407.98,407.78,408.45,410.07z",
                },
              }),
              _vm._v(" "),
              _c("path", {
                staticClass: "st1",
                attrs: {
                  id: "Path_21",
                  d: "M444.03,423.9c2.17-0.31,4.32-0.74,6.44-1.3c8.55-2.78,14.19-10.93,13.75-19.92    c-0.09-1.79-0.72-3.07-2.67-3.06c-1.92,0-2.71,1.2-2.66,3.04c0.02,0.51,0.02,1.03,0,1.55c-0.4,7.6-6.47,13.68-14.07,14.08    c-9.89,0.29-16.9-7.98-15.16-17.9c0.44-2.51-0.18-3.87-1.92-4.18s-2.84,0.74-3.37,3.21C421.69,411.84,431.19,423.58,444.03,423.9z    ",
                },
              }),
              _vm._v(" "),
              _c("path", {
                staticClass: "st1",
                attrs: {
                  id: "Path_22",
                  d: "M444.03,423.9c-11.27-0.19-20.26-9.47-20.07-20.75c0.02-1.26,0.16-2.52,0.41-3.75    c0.53-2.47,1.62-3.51,3.37-3.21c1.74,0.3,2.37,1.67,1.92,4.17c-1.74,9.92,5.27,18.19,15.16,17.9c7.61-0.4,13.68-6.48,14.07-14.08    c0.02-0.51,0.02-1.03,0-1.55c-0.05-1.84,0.75-3.04,2.66-3.04c1.95,0,2.58,1.27,2.67,3.06c0.44,8.98-5.2,17.14-13.75,19.92    C448.34,423.15,446.2,423.6,444.03,423.9z",
                },
              }),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }